<mat-list-item *ngIf="user" [matMenuTriggerFor]="accountMenu">
	<mat-icon mat-list-icon>account_circle</mat-icon>
	<h4 mat-line>{{ fullname }}</h4>
</mat-list-item>
<mat-menu #accountMenu="matMenu" overlapTrigger="false">
	<button mat-menu-item fxLayoutAlign="center center" (click)="signOut()">
		<mat-icon>exit_to_app</mat-icon>
		<span>Sign out</span>
	</button>
</mat-menu>
